export default function parseQueryParams() {
    const queryParams = {};
    for (const pair of new URLSearchParams(window.location.search)) {
        queryParams[pair[0]] = pair[1];
    }
    return queryParams;
}